{
  "name": "radianos",
  "version": "1.0.0",
  "main": "index.js",
  "type": "module",
  "publishConfig": {
    "access": "public"
  },
  "exports": "./dist/index.js",
  "bin": "./dist/index.js",
  "scripts": {
    "dev": "tsup --watch",
    "build": "tsup"
  },
  "keywords": [],
  "author": "Radian OS",
  "license": "ISC",
  "description": "add components to your project",
  "dependencies": {
    "@clack/prompts": "^0.9.1",
    "chalk": "^5.3.0",
    "commander": "^12.1.0",
    "cosmiconfig": "^9.0.0",
    "execa": "^9.5.0",
    "fast-glob": "^3.3.2",
    "fs-extra": "^11.2.0",
    "gradient-string": "^3.0.0",
    "node-fetch": "^3.3.2",
    "ora": "^8.1.0",
    "package-manager-detector": "^0.2.2",
    "prompts": "^2.4.2",
    "tsconfig-paths": "^4.2.0",
    "tsup": "^8.3.5",
    "type-fest": "^4.26.1",
    "zod": "^3.23.8"
  },
  "devDependencies": {
    "@trivago/prettier-plugin-sort-imports": "^5.2.2",
    "@types/fs-extra": "^11.0.4",
    "@types/node": "^22.7.9",
    "@types/prompts": "^2.4.9",
    "prettier": "^3.4.2",
    "prettier-plugin-organize-imports": "^4.1.0",
    "typescript": "^5.6.3"
  }
}